





































import { defineComponent, PropType } from "@vue/composition-api";
import OccIcon from "@/components/Atoms/OccIcon/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import { TemplateRow } from "@/components/Pages/Scout/MessageTemplates/MessageTemplateList/MessageTemplateRow/types";

export default defineComponent({
  name: "MessageTemplateRow",
  components: { OccIcon, OccHeading },
  emits: ["handleClickDelete", "handleClickEdit"],
  props: {
    row: {
      type: Object as PropType<TemplateRow>,
      default: () => []
    }
  },
  setup(props, { emit }) {
    const handleClickDelete = (templateRow: TemplateRow) => {
      emit("delete", templateRow);
    };

    const handleClickEdit = (id: number) => {
      emit("edit", id);
    };

    return {
      handleClickDelete,
      handleClickEdit
    };
  }
});
